import {
  APP_INIT,
  APP_SET_READY,
  APP_SET_ERROR,
  APP_SET_PROVISIONS,
} from '../constants/actionTypes';

export function init() {
  return {
    type: APP_INIT
  }
}

export function setAppReady() {
  return {
    type: APP_SET_READY
  };
}

export function setProvisions(provisions) {
  return {
    type: APP_SET_PROVISIONS,
    payload: provisions
  };
}

export function setAppError(err) {
  return {
    type: APP_SET_ERROR,
    payload: err
  };
}
